import { DaysOfWeek } from '@rivallapp/shared/utils/day-of-week-helpers';
import type { FC } from 'react';

import { withPropsFromUrl } from './utils';
import { FilterSelect } from '../../components';
import type { SharedFilterProps, WithPropsFromUrl } from './types';

const dowOptions = Object.values(DaysOfWeek).map(dow => ({ label: dow.name, value: dow.value }));

const DayFilter: FC<WithPropsFromUrl & SharedFilterProps> = props => {
  const {
    daysOfWeek = [],
    disabled,
    onSelect,
    isMulti,
    className,
    updateSearchUrls,
    miscStyles,
    hideIcon,
    hideIndicator,
  } = props;

  const onChange =
    typeof onSelect === 'function'
      ? onSelect
      : (v = []) => updateSearchUrls({ daysOfWeek: v.map(({ value }) => value) });

  // prev version had "toggleStyle" variant, was confirmed entirely unused

  return (
    <FilterSelect
      short
      shadow
      labelSingular="Day of the Week"
      labelPlural="Days of the Week"
      options={dowOptions}
      value={dowOptions.filter(({ value }) => daysOfWeek.includes(value)) || null}
      onChange={onChange}
      disabled={disabled}
      multi={isMulti}
      className={className}
      miscStyles={miscStyles}
      // @ts-expect-error Incorrect type
      hideIcon={hideIcon}
      hideIndicator={hideIndicator}
    />
  );
};

export default withPropsFromUrl()(DayFilter);
